var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"vx-form-wrapper",attrs:{"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(form){return [_vm._t("default",null,null,form)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }